import React from 'react';
import { Tag } from 'antd';
import { colors } from '@yuhuinc/ui-library';

const ApplicantStatus = ({ applicant }) => {
  return (
    <Tag color={colors.TAG_STATUS_COLORS.applicant[applicant.lifecycle?.substatus]}>
      {applicant.lifecycle?.substatus_label}
    </Tag>
  );
};

export default ApplicantStatus;
